import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { useThemeLocaleData } from '@theme/useThemeData'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPToggleSidebarButton',
  emits: ["toggle"],
  setup(__props) {



const themeLocale = useThemeLocaleData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "vp-toggle-sidebar-button",
    title: _unref(themeLocale).toggleSidebar,
    "aria-expanded": "false",
    role: "button",
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("div", {
      class: "icon",
      "aria-hidden": "true"
    }, [
      _createElementVNode("span"),
      _createElementVNode("span"),
      _createElementVNode("span")
    ], -1)
  ]), 8, _hoisted_1))
}
}

})